import AntdProgress from 'antd/lib/progress';
import React        from 'react';
import useTheme     from '@widesk-ui/hooks/useTheme';

export type ProgressProps = {
	percent?: number;
	showInfo?: boolean;
	status?: 'success' | 'exception' | 'normal' | 'active';
	strokeColor?: string;
	strokeLinecap?: 'round' | 'butt' | 'square';
	size?: number | [number | string, number] | { width?: number, height?: number } | "small" | "default";
	style?: React.CSSProperties;
	success?: { percent: number, strokeColor: string },
	trailColor?: string;
	type: 'circle' | 'dashboard' | 'line';
}

const Progress = (props: ProgressProps) => {
	const theme = useTheme();

	return (
		<AntdProgress
			percent={props.percent}
			showInfo={props.showInfo}
			status={props.status}
			strokeColor={props.strokeColor}
			strokeLinecap={props.strokeLinecap}
			size={props.size}
			style={props.style}
			success={props.success}
			trailColor={props.trailColor || theme.colorBorder}
			type={props.type}
		/>
	);
};

export default Progress;
